import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Alert, Button, Form, Input } from "antd";
import { useState, useRef, useEffect } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import Logo from "../../assets/images/logo2.png";
import { customerLogin } from "../../store/actions/authActionCreators";
import { isUserLoggedIn } from "../../util/auth.util";
import AskPasswordChangeModal from "./AskPasswordChangeModal";
import { saveAuthUserInfo } from "../../components/header/header";

const Login = () => {
  const [form] = Form.useForm();
  const passwordInput = useRef(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [showAskPasswordChangeModal, setShowAskPasswordChangeModal] =
    useState<boolean>(false);
  const [token, setToken] = useState<string>("");

  const history = useHistory();
  const [serverError, setServerError] = useState<string | null>(null);
  const cancelAskPasswordChangeHandler = () => {
    setShowAskPasswordChangeModal(false);
  };
  useEffect(() => {
    if (passwordInput && passwordInput.current) {
      // @ts-ignore: Object is possibly 'null'.
      passwordInput.current.focus();
    }
  }, [passwordInput]);

  const onFinish = async (values: any) => {
    setServerError(null);
    setLoading(true);
    const [response, err] = await customerLogin({ ...values });
    if (response) {
      if (!response.data.authenticated) {
        setServerError("Invalid credentials");
        setLoading(false);
        return;
      }

      if (response.data.askPasswordChange) {
        setShowAskPasswordChangeModal(true);
        setToken(response.data.token);
        setLoading(false);
        form.setFieldsValue({ customerCode: "", password: "" });
      } else {
        saveAuthUserInfo(response);
        window.setTimeout(() => {
          setLoading(false);
          history.push("/");
          window.location.href = window.location.href;
        }, 1000);
      }
    }
    if (err) {
      if (err?.response?.data.succeeded) {
        setServerError(err.response.data.data.errors[0]);
      } else {
        setServerError(err.response.data.message);
      }
      setLoading(false);
    }
  };

  if (isUserLoggedIn()) {
    return <Redirect to="/" />;
  }

  const resendLink = () => {
    history.push("/resend-link");
  };

  return (
    <>
      <div className="authentication__wrapper">
        <div className="authentication__content login">
          <div>
            <img src={Logo} alt="" className="logo__img" />
            <div className="form__wrapper">
              <div className="alert__wrapper">
                {serverError && (
                  <Alert
                    message={serverError}
                    type="error"
                    closable
                    showIcon
                    action={
                      serverError === "Email is not verified." ? (
                        <Button size="small" onClick={resendLink}>
                          RESEND LINK?
                        </Button>
                      ) : (
                        ""
                      )
                    }
                  />
                )}
              </div>
              <Form layout="vertical" form={form} onFinish={onFinish}>
                <Form.Item
                  name="customerCode"
                  rules={[
                    {
                      required: true,
                      message: "Customer Code or Email is required",
                    },
                  ]}
                >
                  <Input
                    style={{ width: "100%" }}
                    ref={passwordInput}
                    placeholder="Customer Code or Email"
                    prefix={<UserOutlined />}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Password is required",
                    },
                  ]}
                >
                  <Input.Password
                    style={{ width: "100%" }}
                    placeholder="Password"
                    prefix={<LockOutlined />}
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    loading={loading}
                    className="login__btn w__100"
                    type="primary"
                    htmlType="submit"
                  >
                    Sign In
                  </Button>
                </Form.Item>
                <p>
                  Forgot password? Click{" "}
                  <Link to="/reset-password-link">here</Link> to reset.
                </p>
                <p>
                  Don't have an account yet? <Link to="/signup">Sign Up</Link>
                </p>
              </Form>
            </div>
          </div>
        </div>
        <div style={{ position: "absolute", bottom: 0, right: 0, padding: 10 }}>
          v{process.env.REACT_APP_VERSION}
        </div>
      </div>
      <AskPasswordChangeModal
        showAskPasswordChangeModal={showAskPasswordChangeModal}
        cancelAskPasswordChangeHandler={cancelAskPasswordChangeHandler}
        token={token}
      />
    </>
  );
};

export default Login;
